import { SelectOption } from "src/app/shared/interfaces/select-option.interface";
import { AdminPagesStateModel } from "../../admin.state";
import { Employer } from "../models/employer.model";

export class EmployersStateModel extends AdminPagesStateModel {
  items: Employer[];
  exportCompanyTypes: SelectOption[];
}